module.exports = __webpack_public_path__ + "static/media/net.3912877b.gif";